import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
	from { opacity: 0; }
	to { opacity: 1; }
`;

const fadeOut = keyframes`
	from { opacity: 1; }
	to { opacity: 0; }
`;

const scaleIn = keyframes`
	from { transform: scale(0.5); }
	to { transform: scale(1); }
`;

const scaleOut = keyframes`
	from { transform: scale(1); }
	to { transform: scale(0.2); }
`;

export const Overlay = styled.div`
	background: rgba(0,0,0, .5);
	backdrop-filter: blur(4px);

	position: fixed;
	left: 0;
	top: 0;

	width: 100%;
	height: 100%;

	display: flex;
	align-items: center;
	justify-content: center;

	animation: ${fadeIn} 0.3s;
	${({ isLeaving }) => isLeaving && css`animation: ${fadeOut} 0.2s;`}
`;

export const Container = styled.div`
	background: #fff;
	padding: 24px;

	border-radius: 4px;
	box-shadow: 0px 4px 10px rgba(0,0,0, .04);

	max-width: 450px;
	width: 100%;

	animation: ${scaleIn} 0.2s;
	${({ isLeaving }) => isLeaving && css`animation: ${scaleOut} 0.2s;`}

	> h1 {
		font-size: 22px;
		color: ${({ theme, danger }) => (
		danger ? theme.colors.danger.main : theme.colors.gray[900]
	)}
	}

	.modal-body {
		margin-top: 32px;
	}

`;

export const Footer = styled.footer`
	margin-top: 32px;

	display: flex;
	align-items: center;
	justify-content: flex-end;

	.cancel-button {
		background: none;
		border: 0;

		font-size: 16px;
		margin-right: 24px;
		color: ${({ theme }) => theme.colors.gray[200]};

		&[disabled] {
			cursor: not-allowed;
		}
	}
`;


